import "./About.scss";
import { useContext } from "react";
import { LangContext } from "../../context/langContext";
import card1 from "../../assets/about-card-1.webp";
import card2 from "../../assets/about-card-2.webp";
import card3 from "../../assets/about-card-3.webp";

const About = ({ textData }) => {
  const lang = useContext(LangContext);

  return (
    <section className="about" id="about">
      <div className="about__cards">
        <div className="about__card">
          <img src={card1} className="about__card-image" alt="" />
          <div className="about__card-text">
            <h3 className="about__card-title">
              {textData[lang].about.cardTitle1}
            </h3>
            <p className="about__card-desc">{textData[lang].about.cardDesc1}</p>
          </div>
        </div>
        <div className="about__card">
          <img src={card2} className="about__card-image" alt="" />
          <div className="about__card-text">
            <h3 className="about__card-title">
              {textData[lang].about.cardTitle2}
            </h3>
            <p className="about__card-desc">{textData[lang].about.cardDesc2}</p>
          </div>
        </div>
        <div className="about__card">
          <img src={card3} className="about__card-image" alt="" />
          <div className="about__card-text">
            <h3 className="about__card-title">
              {textData[lang].about.cardTitle3}
            </h3>
            <p className="about__card-desc">{textData[lang].about.cardDesc3}</p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
